import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import Select from 'react-select'
import { Flex } from 'reflexbox'

import Body from 'components/typography/body2/index'
import styles from '../styles.scss'


class SkuSelectionPage extends Component {
  selectRenderer = ({label, hint, source, property, isLoading}) => {
    return (
      <Flex
        key={property}
        align='center'
        auto
        styleName='userInputContainer'
      >
        <div styleName='userInputHeader'>
          <Body>
            {label} {<span styleName='required'>  *</span>}
          </Body>
        </div>
        <div styleName='selectContainer'>
          <Select
            placeholder={hint}
            value={this.props.productDetails[property]}
            onChange={(newValue) => this.props.handleChange(property, newValue, true)}
            disabled={source.length == 0}
            isLoading={isLoading}
            options={source}
          />
        </div>
      </Flex>
    )
  }

  skuSelectionRenderer = () => {
    const { loadingSkuList } = this.props
    const selectFields = [
      {label: 'Product Segment', hint: 'Select Segment...', property: 'segment', source: this.props.segmentSources, isLoading: false},
      {label: 'Product Line', hint: 'Select Line...', property: 'line', source: this.props.lineSources, isLoading: false},
      {label: 'Product SKU', hint: 'Select SKU (Family, Platform)...', property: 'productSku', source: this.props.productSkuSources, isLoading: loadingSkuList}
    ]
    return (
      <div>
        {selectFields.map(field => this.selectRenderer(field))}
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        <h5>Select SKU Details</h5>
        {this.skuSelectionRenderer()}
      </React.Fragment>
    )
  }
}

export default CSSModules(SkuSelectionPage, styles)
